import { useRef, useEffect } from "react";
import { useAnimation, useInView } from "framer-motion";

const useScrollAnimation = (options = { once: true, margin: "0px" }) => {
  const ref = useRef(null);
  const controls = useAnimation();
  const inView = useInView(ref, options);

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView, controls]);

  return { ref, controls };
};

export default useScrollAnimation;



